import Button from 'components/Button';
import TableComponent from 'components/Table';
import { useCallback } from 'react';
import { PaymentRecord } from 'screens/collections/hotcash/types';
import { renderInfoValue } from 'utils/helpers';
import EditableText from './EditableText';

interface PendingInvoiceTableProps {
  pagination: {
    total: number;
    currentPage: number;
    pageSize: number;
    handlePageChange: (page: number, pageSize: number) => void;
  };
  data: PaymentRecord[];
  isLoading: boolean;
  onPaymentSimulateAction: (
    id: string,
    amount: number,
    externalId: string,
  ) => void;
  onPaymentAmountChange: (id: string, amount: number) => void;
}

const PendingInvoiceTable = ({
  pagination: { total, currentPage, pageSize, handlePageChange },
  data,
  isLoading,
  onPaymentSimulateAction,
  onPaymentAmountChange,
}: PendingInvoiceTableProps) => {
  const renderTableHeader = useCallback(() => {
    return [
      {
        title: 'Invoice Id',
        dataIndex: 'invoiceNumber',
        render: (invoiceNumber: string) =>
          renderInfoValue(invoiceNumber, 'N/A'),
        key: 'invoiceNumber',
      },
      {
        title: 'Invoice Number',
        dataIndex: 'description',
        render: (invoiceNo: string) => renderInfoValue(invoiceNo, 'N/A'),
        key: 'invoiceNo',
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        render: (amount: number, record: PaymentRecord) => {
          return (
            <EditableText
              inputPlaceholder="Enter Amount"
              renderText={() => renderInfoValue(amount, 'N/A')}
              value={amount.toString()}
              onChange={(amount) =>
                onPaymentAmountChange(record?.invoiceNumber, +amount)
              }
            />
          );
        },
      },

      {
        title: 'Action',
        dataIndex: 'invoiceNumber',
        render: (id: string, record: PaymentRecord) => (
          <Button
            type="link"
            onClick={() =>
              onPaymentSimulateAction(
                id,
                record?.amount,
                record?.externalId || '',
              )
            }
            className="p-0"
          >
            Simulate Payment
          </Button>
        ),
        width: 300,
      },
    ];
  }, []);

  return (
    <>
      <TableComponent
        loading={isLoading}
        pagination={{
          total,
          current: currentPage,
          pageSize,
          onChange: handlePageChange,
          onShowSizeChange: handlePageChange,
        }}
        tableColumns={data}
        tableHeader={renderTableHeader()}
        rowKey="id"
      />
    </>
  );
};

export default PendingInvoiceTable;
